<template>
  <div class="editor-popup">
    <div class="editor-popup__content">
      <div class="editor-popup__close" @click="close" />

      <div class="editor-popup__content-type">
        <h3 class="editor-popup__title editor-popup__title--marker">
          Settings
        </h3>
      </div>
      <div class="editor-popup__mark-type">
        <span
          @click="selectMarkType('settings')"
          :class="`tab ${type === 'settings' ? 'selected' : ''}`"
        >Settings</span> /
        <span
          @click="selectMarkType('twitter')"
          :class="`tab ${type === 'twitter' ? 'selected' : ''}`"
        >Twitter</span> /
        <span
          @click="selectMarkType('facebook')"
          :class="`tab ${type === 'facebook' ? 'selected' : ''}`"
        >Facebook</span>
        <!-- <span
          @click="selectMarkType('linkedin')"
          :class="`tab ${type === 'linkedin' ? 'selected' : ''}`"
        >LinkedIn</span> -->
      </div>
      <div v-if="type === 'settings'">
        <div class="field">
          <label class="label">Title</label>
          <input class="input input--outline" placeholder="_" v-model="settingsProject.title" />
        </div>
        <div class="field">
          <label class="label">Description</label>
          <input class="input input--outline" placeholder="_" v-model="settingsProject.description" />
        </div>
        <div class="field">
          <label class="label">Google Analytics</label>
          <input class="input input--outline" placeholder="_" v-model="settingsProject.googleAnalytics" />
        </div>
      </div>
      <div v-if="type === 'twitter'">
        <div class="field">
          <label class="label">Text</label>
          <input class="input input--outline" placeholder="_" v-model="shareProject.twitter.text" />
        </div>
        <div class="field">
          <label class="label">URL</label>
          <input class="input input--outline" placeholder="_" v-model="shareProject.twitter.url" />
        </div>
        <div class="field">
          <label class="label">Hashtags</label>
          <input class="input input--outline" placeholder="_" v-model="shareProject.twitter.hashtags" />
        </div>
      </div>
      <div v-if="type === 'facebook'">
       <div class="field">
          <label class="label">Title</label>
          <input class="input input--outline" placeholder="_" v-model="shareProject.facebook.title" />
        </div>
        <div class="field">
          <label class="label">Description</label>
          <input class="input input--outline" placeholder="_" v-model="shareProject.facebook.description" />
        </div>
        <div class="field">
          <label class="label">Image</label>
          <input class="input input--outline" placeholder="_" v-model="shareProject.facebook.image" />
        </div>
        <div class="field">
          <label class="label">URL</label>
          <input class="input input--outline" placeholder="_" v-model="shareProject.facebook.url" />
        </div>
        <div class="field">
          <label class="label">Quote</label>
          <input class="input input--outline" placeholder="_" v-model="shareProject.facebook.quote" />
        </div>
      </div>
      <div v-if="type === 'linkedin'">
        <div class="field">
          <label class="label">URL</label>
          <input class="input input--outline" placeholder="_" v-model="shareProject.linkedin.url" />
        </div>
      </div>
      <br />
      <button class="button button--info button--mr-20" @click="save">Save</button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

import { getProjectScenes } from "../../../utils";
import api from "../../../api";


export default {
  data() {
    return {
      type: "settings",
      share: {
        facebook: {
          url: "",
          title: "",
          description: "",
          image: ""
        },
        twitter: {
          text: "",
          url: "",
          hashtags: ""
        },
        linkedin: {
          url:""
        }
      },
      settings: {
        title: "",
        description: "",
        googleAnalytics: "",
      }
    };
  },
  computed: {
    ...mapState([
      "selectedProject",
      "unsavedScenes"
    ]),
    shareProject() {
      return this.selectedProject.share || this.share;
    },
    settingsProject() {
      return this.selectedProject.settings || this.settings;
    }
  },
  methods: {
    ...mapMutations([
      "closePopup",
      "saveLocalScene",
      "addUnsavedScene",
      "openSidebar",
      "setSelectedProject"
    ]),
    save() {
      if (!this.selectedProject.share) {
        this.selectedProject.share = this.share;
      }

      if (!this.selectedProject.settings) {
        this.selectedProject.settings = this.settings;
      }

      api.projects.updateProject(this.selectedProject._id, this.selectedProject).then(response => {
        this.setSelectedProject(this.selectedProject);
        this.close();
      }).catch(function (error) {
         console.log(error);
      })
    },
    close() {
      this.closePopup("share");
    },
    selectMarkType(type) {
      this.type = type;
    }
  }
};
</script>

<style lang="scss" scoped>
.button--mr-20 {
  margin-right: 20px;
}

.editor-popup__mark-type {
  display: flex;
  justify-content: center;
}

.tab {
  color: #333;
  cursor: pointer;
  margin: 0 10px 40px;
  user-select: none;

  &.selected {
    color: #00bfff;
  }
}
</style>
